// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__E3JIA","school":"ComboboxCoso_school__Ekdsb","logo":"ComboboxCoso_logo__VNLDw","name":"ComboboxCoso_name__KOCLq"};